var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import cn from 'classnames';
import React, { forwardRef } from 'react';
import { useForwardedRef } from '@anton.bobrov/react-hooks';
import { prefixedClasNames } from '../../utils/prefixedClassNames';
import { useRichTextWrappedChildren } from './utils/useRichTextWrappedChildren';
export var RichTextContent = forwardRef(function (_a, forwardedRef) {
    var className = _a.className, _b = _a.isOverflowTextHidden, isOverflowTextHidden = _b === void 0 ? true : _b, props = __rest(_a, ["className", "isOverflowTextHidden"]);
    var ref = useForwardedRef(forwardedRef);
    var classNames = cn(className, prefixedClasNames('rich-text-content', isOverflowTextHidden && 'is-overflow-text-hidden'));
    var textProps = useRichTextWrappedChildren(props);
    return (React.createElement("div", __assign({ ref: ref }, props, textProps, { className: classNames, 
        // @ts-ignore
        html: undefined })));
});
RichTextContent.displayName = 'RichTextContent';
//# sourceMappingURL=index.js.map